import { getConversationApiConversationsSessionIdGet } from "@noa/api-core";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

export const fetchConversationDetails = async (sessionId: string) => {
  const { data } = await getConversationApiConversationsSessionIdGet({
    path: { session_id: sessionId },
    throwOnError: true,
  });
  return data;
};

export const useConversationDetails = (sessionId: string) => {
  const { data, isLoading, isFetching, isError, error, ...rest } = useQuery<
    Awaited<ReturnType<typeof fetchConversationDetails>>,
    ApiError
  >({
    queryKey: ConversationQueryKey.detail(sessionId),
    queryFn: () => fetchConversationDetails(sessionId),
  });

  return {
    conversationMessages: data?.messages ?? [],
    isLoadingConversationDetails: isLoading,
    isFetchingConversationDetails: isFetching,
    isErrorConversationDetails: isError,
    errorConversationDetails: error,
    ...rest,
  };
};
